import * as React from 'react'
import { IconWrapper } from '../IconWrapper'
import { IconProps } from '../iconConstants'

export const SettingsSliderIcon = ({ title, titleId, ...props }: IconProps) => (
    <IconWrapper {...props}>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            fill="none"
            viewBox="0 0 24 24"
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path
                stroke="currentColor"
                d="M3 8.501h11.5M14.499 8.501a3 3 0 1 0 6 0 3 3 0 0 0-6 0ZM6.499 15.501a3 3 0 1 0 6 0 3 3 0 0 0-6 0ZM3 15.501h3.5M12.5 15.501H21"
            />
        </svg>
    </IconWrapper>
)
